/** @jsxImportSource @emotion/react */
import type { SerializedStyles } from '@emotion/react';
import { css } from '@emotion/react';
import isMobile from 'ismobilejs';
import type { Chat } from '@/types';
import { SystemAuthor } from './Message.Author';
import { SystemUserMessageFooterContainer } from './Message.System.Footer';
import { useStyles } from './Message.System.styles';
import { MessageQueryHints } from './QueryHints';

type Props = {
  className?: string;
  bodyStyles?: SerializedStyles;
  hints?: Chat.QueryHint.Item[];
} & ChildrenProps;

export const BasicSystemUserMessage = ({ bodyStyles, children, className, hints = [] }: Props) => {
  const device = isMobile();
  const styles = useStyles();

  return (
    <div css={styles.root} className={className}>
      {!device.phone && (
        <div css={styles.authorWrap}>
          <SystemAuthor css={styles.author} />
        </div>
      )}
      <div css={css(styles.body, bodyStyles)}>
        {children}
        {!!hints.length && (
          <SystemUserMessageFooterContainer>
            <MessageQueryHints hints={hints} />
          </SystemUserMessageFooterContainer>
        )}
      </div>
    </div>
  );
};